<template>
          <div v-if="wfLoader" class="fw center loader-conatainer">
          <loading-circle />
        </div>
  <div v-else  class="item-master-workflows fh fw">
    <div class="item-master-workflows__card">
      <div class="item-master-workflows__title">
        <img class="item-master-workflows__icon" :src="workflowIcon" alt="Workflows" />
        <span>Active Alternative Material Workflows</span>
      </div>
      <div class="item-master-workflows__list">
        <div v-for="flow in altMaterialWfs" :key="flow.id" class="item-master-workflows__item">
          <div class="item-master-workflows__header">
            <div>
              <div class="item-master-workflows__name">{{ flow.wfTemplateName }}</div>
              <div class="item-master-workflows__stage">Current Stage: {{ flow.activeStage }}</div>
            </div>
            <div :class="['item-master-workflows__status', statusClass(flow.wfStatus)]">
              {{ flow.wfStatus }}
            </div>
          </div>
          <!-- <div class="item-master-workflows__progress">
            <div class="item-master-workflows__bar">
              <div class="item-master-workflows__bar-fill" :style="{ width: flow.progress + '%' }"></div>
            </div>
            <div class="item-master-workflows__percent">{{ flow.progress }}%</div>
          </div> -->
          <div class="item-master-workflows__meta">
            {{ flow.altMaterialName }} | {{  flow.cu }} | Started on {{ flow.createdOn | formatDate }}
          </div>
        </div>
        <div v-if="altMaterialWfs.length === 0" class="item-master-workflows__empty">
          No active workflows
        </div>
      </div>
    </div>
<!-- life cycle wf -->
    <div  class="item-master-workflows__card mt-4">
      <div class="item-master-workflows__title">
        <img class="item-master-workflows__icon" :src="workflowIcon" alt="Workflows" />
        <span> Active Life Cycle Workflows</span>
      </div>
      <div  class="item-master-workflows__list">
        <div v-if="lifeCycleWfs.id" class="item-master-workflows__item">
          <div class="item-master-workflows__header">
            <div>
              <div class="item-master-workflows__name">{{ lifeCycleWfs.wfTemplateName }}</div>
              <div class="item-master-workflows__stage">Current Stage: {{ lifeCycleWfs.activeStage }}</div>
            </div>
            <div :class="['item-master-workflows__status', statusClass(lifeCycleWfs.wfStatus)]">
              {{ lifeCycleWfs.wfStatus }}
            </div>
          </div>
          <!-- <div class="item-master-workflows__progress">
            <div class="item-master-workflows__bar">
              <div class="item-master-workflows__bar-fill" :style="{ width: flow.progress + '%' }"></div>
            </div>
            <div class="item-master-workflows__percent">{{ flow.progress }}%</div>
          </div> -->
          <div class="item-master-workflows__meta">
            Started on {{ lifeCycleWfs.createdOn | formatDate }}
          </div>
        </div>
        <div v-else class="item-master-workflows__empty">
          No active workflows
        </div>
      </div>
    </div>
    <!-- life cycle wf -->
  </div>
</template>

<script>
import { AlternateMaterials, getworkflowInstanceBasicData } from '@/api'
import { alert } from '@/plugins/notification'
import LoadingCircle from '@/components/common/loadingCircle.vue'

export default {
  name: 'ItemMasterActiveWorkflowsSection',
  props: {
    materialMaster: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    workflowIcon () {
      return require('@/assets/images/icons/workflow-icon.svg')
    }
  },
  components: {
    LoadingCircle
  },
  filters: {
    formatDate (value) {
      if (!value) return '--'
      return new Date(value).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      })
    }
  },
  data () {
    return {
      altMaterialWfs: [],
      lifeCycleWfs: {},
      wfLoader: false
    }
  },
  methods: {
    statusClass (status) {
      switch ((status || '').toUpperCase()) {
      case 'NOT_STARTED':
        return 'status-not-started'
      case 'ONGOING':
        return 'status-ongoing'
      case 'COMPLETED':
        return 'status-completed'
      case 'CANCELLED':
      case 'REJECTED':
        return 'status-cancelled'
      default:
        return 'status-neutral'
      }
    },
    getAltMaterialWorkflowsData () {
      return new Promise((resolve, reject) => {
        AlternateMaterials(this.materialMaster.id).then((res) => {
          for (const alt of res.alternate_materials) {
            this.altMaterialWfs.push({
              wfTemplateName: alt.workflow_instance?.workflow_version?.workflow_template?.name ?? '--',
              activeStage: alt.workflow_instance?.workflow_stage?.name ?? '--',
              wfStatus: alt.workflow_instance?.state_value?.name,
              altMaterialName: alt?.alternate_material?.material_name,
              altMaterialCusId: alt?.alternate_material?.custom_material_id,
              createdOn: alt?.workflow_instance?.created_on,
              id: alt?.workflow_instance?.id
            })
          }
          resolve()
        })
          .catch((err) => {
            alert('Unable to fetch alternate material workflows')
            reject(err)
          })
      })
    },
    getLifeCycleWorkflowData () {
      return new Promise((resolve, reject) => {
        if (!this.materialMaster.ongoing_lifecycle_workflow_id) {
          this.lifeCycleWfs = {}
          resolve()
          return
        }
        getworkflowInstanceBasicData(this.materialMaster.ongoing_lifecycle_workflow_id).then((res) => {
          if (!res.workflow_instances_by_pk) {
            this.lifeCycleWfs = {}
            resolve()
          }
          this.lifeCycleWfs = {
            wfTemplateName: res.workflow_instances_by_pk?.workflow_version?.workflow_template?.name,
            activeStage: res.workflow_instances_by_pk?.workflow_stage?.name,
            wfStatus: res.workflow_instances_by_pk?.state_value?.name,
            createdOn: res?.workflow_instances_by_pk?.created_on,
            id: res.workflow_instances_by_pk?.id
          }
          resolve()
        })
          .catch((err) => {
            alert('Unable to fetch workflows')
            reject(err)
          })
      })
    }

  },
  mounted () {
    this.wfLoader = true
    Promise.allSettled([this.getLifeCycleWorkflowData(), this.getAltMaterialWorkflowsData()]).then(res => {
      this.wfLoader = false
    })
      .catch(() => {
        this.wfLoader = false
      })
  }
}
</script>

<style lang="scss" scoped>
.item-master-workflows {
  padding: 24px 32px 8px 32px;

  &__card {
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    padding: 20px 22px;
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08);
  }

  &__title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 400;
    font-size: var(--text-s);
    color: #0f172a;
    margin-bottom: 16px;
  }

  &__icon {
    width: 15px;
    height: 15px;
    filter: invert(54%) sepia(48%) saturate(531%) hue-rotate(350deg) brightness(90%) contrast(90%);
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  &__item {
    border: 1px solid rgba(148, 163, 184, 0.35);
    border-radius: 14px;
    padding: 16px 18px;
    background: linear-gradient(135deg, rgba(239, 246, 255, 0.9), rgba(248, 250, 252, 0.9));
    box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08);
    transition: transform 180ms ease, box-shadow 200ms ease, border-color 200ms ease;
    animation: wfItemPop 280ms ease both;
  }
  &__item:hover {
    transform: translateY(-2px);
    border-color: rgba(59, 130, 246, 0.5);
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);
  }

  &__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
  }

  &__name {
    font-weight: 400;
    color: #0f172a;
  }

  &__stage {
    font-size: var(--text-xs2);
    color: #475569;
  }

  &__status {
    font-size:var(--text-xs2);
    font-weight: 400;
    padding: 4px 10px;
    border-radius: 8px;
    text-transform: uppercase;
    letter-spacing: 0.4px;
  }

  &__status.status-not-started {
    background-color: rgba(255, 0, 0, 0.1);
    color: purple;
  }

  &__status.status-ongoing {
    background-color: rgba(255, 165, 0, 0.1);
    color: orange;
  }

  &__status.status-completed {
    background-color: rgba(0, 128, 0, 0.1);
    color: green;
  }

  &__status.status-cancelled {
    background-color: rgba(198, 39, 52, 0.1);
    color: red;
  }

  &__status.status-neutral {
    background-color: rgba(148, 163, 184, 0.15);
    color: #475569;
  }

  // &__progress {
  //   display: grid;
  //   grid-template-columns: 1fr auto;
  //   gap: 12px;
  //   align-items: center;
  //   margin: 12px 0 6px;
  // }

  // &__bar {
  //   width: 100%;
  //   height: 6px;
  //   background: #e2e8f0;
  //   border-radius: 999px;
  //   overflow: hidden;
  // }

  // &__bar-fill {
  //   height: 100%;
  //   background: #f59e0b;
  //   border-radius: inherit;
  // }

  // &__percent {
  //   font-size: 12px;
  //   font-weight: 600;
  //   color: #0f172a;
  // }

  &__meta {
    font-size: var(--text-xs1);
    color: #64748b;
    margin-top: 6px;
  }

  &__empty {
    color: #94a3b8;
    font-size: 13px;
  }
}
 .loader-conatainer{
    flex-grow: 1;
    min-width: fit-content;
    min-height: fit-content;
}

@keyframes wfItemPop {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .item-master-workflows__item {
    animation: none;
    transition: none;
  }
}
@media (max-width: 768px) {
  .item-master-workflows {
    padding: 20px;
  }
}
</style>
